// Primitive types shared across the simulator.
/** Per-second rate expressed in ticks (30 ticks = 1 second at 30 Hz). */
export const TICKS_PER_SECOND = 30;
export const seconds = (s) => Math.round(s * TICKS_PER_SECOND);
//# sourceMappingURL=primitives.js.map